// extracted by mini-css-extract-plugin
module.exports = {"root":"TextInput_root__6Ifyw","error":"TextInput_error__pqVFf"};